import React from 'react';
import { useLocation, NavLink, Link } from 'react-router-dom';
import { MODULOS } from '../config/modulos';
import { useAdmin } from '../context/AdminContext';
import { useRRHH } from '../context/RRHHContext';

// Iconos SVG inline preservados de la NavBar v36, re-mapeados a las rutas
// nuevas /app/* (v37.0). Se mantienen tal cual para no reescribir iconos
// que ya funcionan (spec v37.0 S5).
const ICONOS = {
  '/app/cxp/proveedores': (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="7" r="4" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M3 17c0-3.314 3.134-6 7-6s7 2.686 7 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  '/app/cxp/cotizaciones-proveedor': (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
      <rect x="3" y="2" width="14" height="16" rx="2" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M7 7h6M7 10h6M7 13h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  '/app/cxp/facturas-proveedor': (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
      <rect x="3" y="2" width="14" height="16" rx="2" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M7 7h6M7 10h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M7 13h2M12 13h2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  '/app/cxp/pagos-proveedor': (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
      <rect x="2" y="5" width="16" height="11" rx="2" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M2 8h16" stroke="currentColor" strokeWidth="1.5"/>
      <circle cx="6" cy="12" r="1.5" fill="currentColor"/>
      <path d="M10 12h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  '/app/cxc/clientes': (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
      <circle cx="7" cy="7" r="3" stroke="currentColor" strokeWidth="1.5"/>
      <circle cx="14" cy="7" r="3" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M1 17c0-2.761 2.686-5 6-5M10 17c0-2.761 2.686-5 6-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  '/app/cxc/ofertas-cliente': (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
      <rect x="3" y="2" width="14" height="16" rx="2" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M7 7h6M7 10h6M7 13h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M12 12l2 2 3-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  '/app/cxc/proyectos': (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
      <rect x="2" y="3" width="16" height="14" rx="2" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M6 8h8M6 11h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="14" cy="13" r="2" fill="currentColor"/>
    </svg>
  ),
  '/app/cxc/cobros-cliente': (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
      <rect x="2" y="5" width="16" height="11" rx="2" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M2 8h16" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M6 12h3M13 12h1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  '/app/cxc/pagos-cliente': (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="7" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M10 6v8M7.5 8.5h3.5a1.5 1.5 0 0 1 0 3H8.5a1.5 1.5 0 0 0 0 3H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  '/app/cxc/proyeccion-facturacion': (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
      <rect x="2" y="3" width="16" height="14" rx="2" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M2 8h16M7 3v14M12 3v14" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
  ),
  '/app/cxc/proyectos-por-cerrar': (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="7" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M7 10l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  '/app/configuracion': (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M10 2v2M10 16v2M2 10h2M16 10h2M4.22 4.22l1.42 1.42M14.36 14.36l1.42 1.42M4.22 15.78l1.42-1.42M14.36 5.64l1.42-1.42"
        stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  '/app/gastos/registro': (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
      <rect x="2" y="5" width="16" height="11" rx="2" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M13 10h2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M2 8h10" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
  ),
  '/app/gastos/recurrentes': (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
      <path d="M4 10a6 6 0 0 1 10-4.5M16 10a6 6 0 0 1-10 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      <path d="M14 3v3h-3M6 17v-3h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  '/app/gastos/aprobacion': (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="7.5" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M6.5 10l2.5 2.5L14 7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  '/app/gastos/catalogos': (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
      <path d="M4 4h12M4 8h12M4 12h8M4 16h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  '/app/rrhh/expedientes': (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
      <rect x="3" y="2" width="14" height="16" rx="2" stroke="currentColor" strokeWidth="1.5"/>
      <circle cx="10" cy="8" r="2.2" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M6.5 14.5c0-1.8 1.6-3 3.5-3s3.5 1.2 3.5 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  ),
  '/app/rrhh/acciones': (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
      <path d="M4 3h9l3 3v11a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
      <path d="M6.5 12l2 2 4.5-4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  '/app/rrhh/catalogos': (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
      <path d="M4 4h12M4 8h12M4 12h8M4 16h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  )
};

// Sidebar contextual (v37.0). Muestra solo los submenus del modulo activo,
// detectado por pathname contra el catalogo MODULOS (no lista hardcoded).
// Se auto-oculta en /app/inicio y fuera de /app/*.
function NavBar() {
  // TODOS los hooks al tope, ANTES de cualquier return (Rules of Hooks).
  const { pathname } = useLocation();
  const isAdmin = useAdmin();
  const esRRHH = useRRHH();

  // Logica de derivacion (sin hooks).
  const debeOcultarse = pathname === '/app/inicio' || !pathname.startsWith('/app/');
  const moduloActivo = MODULOS.find(m =>
    m.submenus?.some(s => pathname.startsWith(s.ruta)) ||
    (m.rutaPorDefecto && pathname.startsWith(m.rutaPorDefecto))
  );

  // Returns condicionales (sin hooks por debajo).
  if (debeOcultarse) return null;
  if (!moduloActivo) return null;
  if (moduloActivo.estado === 'admin' && !isAdmin) return null;
  if (moduloActivo.rol === 'rrhh' && !esRRHH) return null;   // v49 D16

  const linkStyle = ({ isActive }) => ({
    display: 'flex', alignItems: 'center', gap: '11px',
    padding: '9px 12px', borderRadius: '9px', marginBottom: '2px',
    textDecoration: 'none', fontSize: '13px', fontWeight: '500',
    borderLeft: `3px solid ${isActive ? '#87B749' : 'transparent'}`,
    background: isActive ? 'rgba(135,183,73,0.18)' : 'transparent',
    color: isActive ? '#fff' : 'rgba(255,255,255,0.6)',
    transition: 'background 0.15s, color 0.15s'
  });

  return (
    <aside style={{
      width: 180, height: '100%', background: '#012E40',
      display: 'flex', flexDirection: 'column', flexShrink: 0
    }}>
      <Link to="/app/inicio" style={{
        padding: '14px', color: 'rgba(255,255,255,0.6)',
        textDecoration: 'none', fontSize: 13,
        borderBottom: '1px solid rgba(255,255,255,0.08)', flexShrink: 0
      }}>&larr; Inicio</Link>

      <div style={{
        padding: '12px 14px 8px',
        color: '#87B749', fontSize: 10, fontWeight: 700,
        textTransform: 'uppercase', letterSpacing: 1
      }}>
        {moduloActivo.titulo}
      </div>

      <div style={{ padding: '0 8px', flex: 1, overflowY: 'auto' }}>
        {moduloActivo.submenus
          .filter(s => !(s.admin && !isAdmin))
          .map(s => (
            <NavLink key={s.ruta} to={s.ruta} style={linkStyle}>
              {ICONOS[s.ruta] || null}
              {s.label}
            </NavLink>
          ))}
      </div>
    </aside>
  );
}

export default NavBar;
